import { message } from "antd";
import { authHeader } from "../../../../helpers/auth-header";
import { client } from "../../../../actions";
import uri from "../../constants/uri";

const getTemplates = async () => {
	try {
		const response = await client.get(`${uri}/templates`, {
			headers: authHeader(),
		});
		return response.data;
	} catch (error) {
		console.error(error);
		message.error("Не получилось загрузить шаблоны оповещения");
	}
};

export default getTemplates;
